import axios from "./index.service";

export default class ChatService {
  static fetchUserPrivateChats(receiverId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/private/${receiverId}`,
    });
  }

  static addUserFriend(receiverId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/add-user/${receiverId}`,
    });
  }

  static fetchUserPrivateCount(receiverId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/private/${receiverId}/count`,
    });
  }

  static fetchMessage(id) {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/${id}`,
    });
  }

  static fetchUserFriends() {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/private-users`,
    });
  }

  static fetchStudentInfo(name) {
    return axios({
      method: "GET",
      url: `/api/services/v1/chats/users`,
      params: {
        name: name,
      },
    });
  }
}
